import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const StatusShape = {
  statuspage_id: Yup.string().label("Status Page ID").min(24).max(24).required(),
  api_id: Yup.string().label("API ID").min(36).max(36).required(),
  api_key: Yup.string().label("API Key").min(64).max(256).required(),
  component: Yup.string().label("Component ID").min(24).max(24).optional(),
  container: Yup.string().label("Container ID").min(24).max(24).optional(),
  metric: Yup.string().label("Metric ID").min(24).max(24).optional(),
};

export interface StatusInput {
  statuspage_id: string;
  api_id: string;
  api_key: string;
  component?: string;
  container?: string;
  metric?: string;
}

yupResolver<StatusInput>(Yup.object().shape(StatusShape));
